export default __webpack_public_path__ + "static/media/poppiegifnew.3b229e52.gif";